

export default function(to, from, savedPosition) {
      // 页面切换滚动行为
      return { x: 0, y: 0 }; // 总是滚动到顶部
    }
